import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import toast from 'react-hot-toast';

import { useApproveQueueItemMutation } from '@/store/api/services/marketing/queue';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

import type { QueueItem } from '@/types';

const ApproveQueueItem = ({ hide, props }: ModalChildrenProps) => {
  const item = props?.data as QueueItem;
  const [approveQueueItem, { isLoading }] = useApproveQueueItemMutation();

  const handleSubmit = async () => {
    try {
      await approveQueueItem({ id: item.id }).unwrap();
      hide();
      toast.success(`Queue item for location ${item.location_id} published successfully.`);
    } catch (_err) {
      const meta = (_err as { data?: { meta?: string } })?.data?.meta;
      toast.error(meta ?? 'Failed to publish queue item.');
    }
  };

  return (
    <>
      <DialogContent sx={{ my: 2 }}>
        <Typography variant="h6">Publish Queue Item</Typography>
        <Typography mt={1} variant="body1">
          Are you sure you want to publish the queued <b>{item?.action}</b> for location{' '}
          <b>{item?.location_name ?? item?.location_id}</b>?
        </Typography>
        <Typography mt={1} variant="body2" color="text.secondary">
          This will apply the proposed changes to the live listing.
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Cancel</Button>
        <LoadingButton variant="contained" onClick={handleSubmit} loading={isLoading}>
          Publish
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default ApproveQueueItem;
